<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1><i class="fa fa-dashboard"></i> {{ $t('reportContract') }}</h1>
      </div>
      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item"><router-link to="/report/client">{{ $t('reportContract') }}</router-link></li>
      </ul>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <form-select @change="load" :model="filterFormModel" attribute="group" class="mr-1" :options="[
                            {value:'day',text:$t('byDays')},
                            {value:'week',text:$t('byWeeks')},
                            {value:'month',text:$t('byMonths')},
                            {value:'plan',text:$t('byPlans')},
                            {value:'sale',text:$t('bySales')},
                            {value:'category',text:$t('byCategories')}]">
            </form-select>
            <time-range-picker :model="filterFormModel" :label="$t('time')" :defaultShortcut="3"
                               class="mr-1"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1">{{ $t('search') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="table-responsive c-template-table">
            <table class="table table-hover table-bordered">
              <thead>
                <tr>
                  <th rowspan="3"></th>
                  <th :colspan="clientSizeGroup.length + saleTimeGroup.length + contractValueGroup.length + contractTimeGroup.length + (filterFormModel.group === 'category' ? 9 : 8)" class="text-center">{{ $t('buyNewContract')}}</th>
                  <th :colspan="clientSizeGroup.length + saleTimeGroup.length + contractValueGroup.length + contractTimeGroup.length + 8" class="text-center">{{ $t('extendContract')}}</th>
                </tr>
                <tr>
                  <!-- new -->
                  <th v-if="filterFormModel.group === 'category'" rowspan="2" class="text-center align-middle" style="min-width: 100px">{{ $t('registerRate') }}</th>
                  <th rowspan="2" class="text-center align-middle" style="min-width: 100px">{{ $t('buyNewRate') }}</th>
                  <th rowspan="2" class="text-center align-middle" style="min-width: 100px">{{ $t('contractNumber') }}</th>
                  <th :colspan="clientSizeGroup.length" class="text-center align-middle">{{ $t('contractNumberByUser') }}</th>
                  <th :colspan="saleTimeGroup.length" class="text-center align-middle">{{ $t('contractNumberBySaleTime') }}</th>
                  <th class="text-center align-middle" colspan="3">{{ $t('saleTime') }} ({{ $t('day') }})</th>
                  <th :colspan="contractValueGroup.length" class="text-center align-middle">{{ $t('contractNumberByValue') }}</th>
                  <th :colspan="contractTimeGroup.length" class="text-center align-middle">{{ $t('contractNumberByTime') }}</th>
                  <th colspan="3" class="text-center align-middle">{{ $t('contractTime') }} ({{ $t('month') }})</th>
                  <!-- extend -->
                  <th rowspan="2" class="text-center align-middle" style="min-width: 100px">{{ $t('extendRate') }}</th>
                  <th rowspan="2" class="text-center align-middle" style="min-width: 100px">{{ $t('contractNumber') }}</th>
                  <th :colspan="clientSizeGroup.length" class="text-center align-middle">{{ $t('contractNumberByUser') }}</th>
                  <th :colspan="contractValueGroup.length" class="text-center align-middle">{{ $t('contractNumberByValue') }}</th>
                  <th :colspan="contractTimeGroup.length" class="text-center align-middle">{{ $t('contractNumberByTime') }}</th>
                  <th colspan="3" class="text-center align-middle">{{ $t('contractTime') }} ({{ $t('month') }})</th>
                </tr>
                <tr>
                  <!-- new -->
                  <th v-for="(item, i) in clientSizeGroup" :key="i + 'i27'" style="min-width: 118px" class="text-center align-middle">{{ getGroupHeader(item) }} user</th>
                  <th v-for="(item, i) in saleTimeGroup" :key="i + 'i26'" style="min-width: 118px" class="text-center align-middle">{{ getGroupHeader(item) }} {{ $t('day') }}</th>
                  <th class="text-center align-middle" style="min-width: 100px">{{ $t('shortest') }}</th>
                  <th class="text-center align-middle" style="min-width: 100px">{{ $t('average') }}</th>
                  <th class="text-center align-middle" style="min-width: 100px">{{ $t('longest') }}</th>
                  <th v-for="(item, i) in contractValueGroup" :key="i + 'i25'" style="min-width: 118px" class="text-center align-middle">{{ getGroupHeader(item) }} {{ $t('million') }}</th>
                  <th v-for="(item, i) in contractTimeGroup" :key="i + 'i24'" style="min-width: 118px" class="text-center align-middle">{{ getGroupHeader(item) }} {{ $t('month') }}</th>
                  <th class="text-center align-middle" style="min-width: 100px">{{ $t('shortest') }}</th>
                  <th class="text-center align-middle" style="min-width: 100px">{{ $t('average') }}</th>
                  <th class="text-center align-middle" style="min-width: 100px">{{ $t('longest') }}</th>
                  <!-- extend -->
                  <th v-for="(item, i) in clientSizeGroup" :key="i + 'i23'" style="min-width: 118px" class="text-center align-middle">{{ getGroupHeader(item) }} user</th>
                  <th v-for="(item, i) in contractValueGroup" :key="i + 'i22'" style="min-width: 118px" class="text-center align-middle">{{ getGroupHeader(item) }} {{ $t('million') }}</th>
                  <th v-for="(item, i) in contractTimeGroup" :key="i + 'i21'" style="min-width: 118px" class="text-center align-middle">{{ getGroupHeader(item) }} {{ $t('month') }}</th>
                  <th class="text-center align-middle" style="min-width: 100px">{{ $t('shortest') }}</th>
                  <th class="text-center align-middle" style="min-width: 100px">{{ $t('average') }}</th>
                  <th class="text-center align-middle" style="min-width: 100px">{{ $t('longest') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr class="bg-success">
                  <td><b class="text-uppercase">{{ $t('total') }}</b></td>
                  <!-- new -->
                  <td v-if="filterFormModel.group === 'category'" class="text-center"> <span class="text-blue">100%</span></td>
                  <td v-if="filterFormModel.group === 'plan'" class="text-center"><span class="text-blue">{{ sum.new && sum.new.total && sum.register ? sum.new.total / sum.register * 100 : 0 | numFormat('0.00') }}%</span> </td>
                  <td v-else class="text-center"> <span class="text-blue">{{ sum.new && sum.new.total && sum.new.register ? sum.new.total / sum.new.register * 100 : 0 | numFormat('0.00') }}%</span> </td>
                  <td class="text-center"><span class="text-blue">{{ sum.new && sum.new.total ? sum.new.total : 0 | numFormat  }}</span></td>
                  <td v-for="({}, i) in clientSizeGroup" :key="i + 'i20'" class="text-center">
                    <span class="text-blue">{{ sum.new && sum.new.clientSize ? sum.new.clientSize[i] : 0 | numFormat }}</span>
                  </td>
                  <td v-for="({}, i) in saleTimeGroup" :key="i + 'i19'" class="text-center">
                    <span class="text-blue">{{ sum.new && sum.new.saleTime ? sum.new.saleTime[i] : 0 | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ sum.new && sum.new.minSaleTime ? sum.new.minSaleTime : 0 | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.new && sum.new.avgSaleTime ? sum.new.avgSaleTime : 0 | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.new && sum.new.maxSaleTime ? sum.new.maxSaleTime : 0| numFormat}}</span></td>
                  <td v-for="({}, i) in contractValueGroup" :key="i + 'i18'" class="text-center">
                    <span class="text-blue">{{ sum.new && sum.new.contractValue ? sum.new.contractValue[i] : 0 | numFormat }}</span>
                  </td>
                  <td v-for="({}, i) in contractTimeGroup" :key="i + 'i17'" class="text-center">
                    <span class="text-blue">{{ sum.new && sum.new.contractTime ? sum.new.contractTime[i] : 0 | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ sum.new && sum.new.minContractTime ? sum.new.minContractTime : 0 | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.new && sum.new.avgContractTime ? sum.new.avgContractTime : 0| numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.new && sum.new.maxContractTime ? sum.new.maxContractTime : 0| numFormat}}</span></td>
                  <!-- extend -->
                  <td class="text-center"><span class="text-blue">100%</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.extend && sum.extend.total ? sum.extend.total : 0 }}</span></td>
                  <td v-for="({}, i) in clientSizeGroup" :key="i + 'i16'" class="text-center">
                    <span class="text-blue">{{ sum.extend && sum.extend.clientSize ? sum.extend.clientSize[i] : 0 | numFormat }}</span>
                  </td>
                  <td v-for="({}, i) in contractValueGroup" :key="i + 'i15'" class="text-center">
                    <span class="text-blue">{{ sum.extend && sum.extend.contractValue ? sum.extend.contractValue[i] : 0 | numFormat }}</span>
                  </td>
                  <td v-for="({}, i) in contractTimeGroup" :key="i + 'i14'" class="text-center">
                    <span class="text-blue">{{ sum.extend && sum.extend.contractTime ? sum.extend.contractTime[i] : 0 | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ sum.extend && sum.extend.minContractTime ? sum.extend.minContractTime : 0 | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.extend && sum.extend.avgContractTime ? sum.extend.avgContractTime : 0 | numFormat('0.00') }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.extend && sum.extend.maxContractTime ? sum.extend.maxContractTime : 0 | numFormat }}</span></td>
                </tr>
                <tr class="bg-warning">
                  <td><b class="text-uppercase">{{ $t('average') }}</b></td>
                  <!-- new -->
                  <td v-if="filterFormModel.group === 'category'" class="text-center"><span class="text-blue">{{100 / (data.length ? data.length : 1) | numFormat('0.00') }}%</span></td>
                  <td v-if="filterFormModel.group === 'plan'" class="text-center"><span class="text-blue">{{ avg.new && avg.new.total && avg.register ? avg.new.total / avg.register * 100 : 0 | numFormat('0.00') }}%</span> </td>
                  <td v-else class="text-center"> <span class="text-blue">{{ avg.new && avg.new.total && avg.new.register ? avg.new.total / avg.new.register * 100 : 0 | numFormat('0.00') }}%</span> </td>
                  <td class="text-center"><span class="text-blue">{{ avg.new && avg.new.total ? avg.new.total : 0 | numFormat('0.00') }}</span></td>
                  <td v-for="({}, i) in clientSizeGroup" :key="i + 'i13'" class="text-center">
                    <span class="text-blue">{{ avg.new && avg.new.clientSize ? avg.new.clientSize[i] : 0 | numFormat('0.00') }}</span>
                  </td>
                  <td v-for="({}, i) in saleTimeGroup" :key="i + 'i12'" class="text-center">
                    <span class="text-blue">{{ avg.new && avg.new.saleTime ? avg.new.saleTime[i] : 0 | numFormat('0.00') }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ avg.new && avg.new.minSaleTime ? avg.new.minSaleTime : 0 | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.new && avg.new.avgSaleTime ? avg.new.avgSaleTime : 0 | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.new && avg.new.maxSaleTime ? avg.new.maxSaleTime : 0 | numFormat}}</span></td>
                  <td v-for="({}, i) in contractValueGroup" :key="i + 'i34'" class="text-center">
                    <span class="text-blue">{{ avg.new && avg.new.contractValue ? avg.new.contractValue[i] : 0 | numFormat('0.00') }}</span>
                  </td>
                  <td v-for="({}, i) in contractTimeGroup" :key="i + 'i11'" class="text-center">
                    <span class="text-blue">{{ avg.new && avg.new.contractTime ? avg.new.contractTime[i] : 0 | numFormat('0.00') }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ avg.new && avg.new.minContractTime ? avg.new.minContractTime : 0 | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.new && avg.new.avgContractTime ? avg.new.avgContractTime : 0 | numFormat('0.00') }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.new && avg.new.maxContractTime ? avg.new.maxContractTime : 0 | numFormat}}</span></td>
                  <!-- extend -->
                  <td class="text-center"><span class="text-blue">{{ 100 / (data.length ? data.length : 1) | numFormat('0.00') }}%</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.extend && avg.extend.total ? avg.extend.total : 0 | numFormat('0.00') }}</span></td>
                  <td v-for="({}, i) in clientSizeGroup" :key="i + 'i10'" class="text-center">
                    <span class="text-blue">{{ avg.extend && avg.extend.clientSize ? avg.extend.clientSize[i] : 0 | numFormat('0.00') }}</span>
                  </td>
                  <td v-for="({}, i) in contractValueGroup" :key="i + 'i9'" class="text-center">
                    <span class="text-blue">{{ avg.extend && avg.extend.contractValue ? avg.extend.contractValue[i] : 0 | numFormat('0.00') }}</span>
                  </td>
                  <td v-for="({}, i) in contractTimeGroup" :key="i + 'i8'" class="text-center">
                    <span class="text-blue">{{ avg.extend && avg.extend.contractTime ? avg.extend.contractTime[i] : 0 | numFormat('0.00') }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ avg.extend && avg.extend.minContractTime ? avg.extend.minContractTime : 0 | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.extend && avg.extend.avgContractTime ? avg.extend.avgContractTime : 0 | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.extend && avg.extend.maxContractTime ? avg.extend.maxContractTime : 0 | numFormat}}</span></td>
                </tr>
                <tr :key="index" v-for="(item, index) in data">
                  <td style="min-width: 200px">{{ label(item) }}</td>
                  <!-- new -->
                  <td v-if="filterFormModel.group === 'category'" class="text-center">
                    <span class="text-blue">{{ item.new && item.new.register && sum.new && sum.new.register ? item.new.register / sum.new.register * 100 : 0 | numFormat('0.00') }}%</span>
                  </td>
                  <td class="text-center"> <span class="text-blue">{{ item.new && item.new.buyNewRate ? item.new.buyNewRate : 0 | numFormat('0.00') }}%</span> </td>
                  <td class="text-center"><span class="text-blue">{{ item.new && item.new.total ? item.new.total : 0 }}</span></td>
                  <td v-for="({}, i) in clientSizeGroup" :key="i + 'i7'" class="text-center">
                    <span class="text-blue">{{ item.new && item.new.clientSize ? item.new.clientSize[i] : 0 | numFormat }}</span>
                  </td>
                  <td v-for="({}, i) in saleTimeGroup" :key="i + 'i6'" class="text-center">
                    <span class="text-blue">{{ item.new && item.new.saleTime ? item.new.saleTime[i] : 0 | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ item.new && item.new.minSaleTime ? item.new.minSaleTime : 0 | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.new && item.new.avgSaleTime ? item.new.avgSaleTime : 0 | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.new && item.new.maxSaleTime ? item.new.maxSaleTime : 0| numFormat}}</span></td>
                  <td v-for="({}, i) in contractValueGroup" :key="i + 'i5'" class="text-center">
                    <span class="text-blue">{{ item.new && item.new.contractValue ? item.new.contractValue[i] : 0 | numFormat }}</span>
                  </td>
                  <td v-for="({}, i) in contractTimeGroup" :key="i + 'i4'" class="text-center">
                    <span class="text-blue">{{ item.new && item.new.contractTime ? item.new.contractTime[i] : 0 | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ item.new && item.new.minContractTime ? item.new.minContractTime : 0 | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.new && item.new.avgContractTime ? item.new.avgContractTime : 0 | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.new && item.new.maxContractTime ? item.new.maxContractTime : 0 | numFormat}}</span></td>
                  <!-- extend -->
                  <td class="text-center"><span class="text-blue">{{ item.extend ? item.extend.total / sum.extend.total * 100: 0 | numFormat('0.00')}}%</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.extend ? item.extend.total : 0 }}</span></td>
                  <td v-for="({}, i) in clientSizeGroup" :key="i + 'i3'" class="text-center">
                    <span class="text-blue">{{ item.extend && item.extend.clientSize ? item.extend.clientSize[i] : 0 | numFormat }}</span>
                  </td>
                  <td v-for="({}, i) in contractValueGroup" :key="i + 'i2'" class="text-center">
                    <span class="text-blue">{{ item.extend && item.extend.contractValue ? item.extend.contractValue[i] : 0 | numFormat }}</span>
                  </td>
                  <td v-for="({}, i) in contractTimeGroup" :key="i + 'i1'" class="text-center">
                    <span class="text-blue">{{ item.extend && item.extend.contractTime ? item.extend.contractTime[i] : 0 | numFormat }}</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ item.extend && item.extend.minContractTime ? item.extend.minContractTime : 0 | numFormat}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.extend && item.extend.avgContractTime ? item.extend.avgContractTime : 0 | numFormat('0.00')}}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.extend && item.extend.maxContractTime ? item.extend.maxContractTime : 0| numFormat}}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import moment from 'moment';
import TimeRangePicker from "../../components/TimeRangePicker";
// import VueApexCharts from 'vue-apexcharts';
import _ from 'lodash';

export default {
  components: {
    TimeRangePicker,
    // 'apexchart': VueApexCharts
  },
  data() {
    return {
      currentTab: 0,
      filterFormModel: {
        group: 'day',
      },
      loading: true,
      data: [],
      sum: {},
      avg: {},
      saleTimeGroup: [
        {from: null, to: 3},
        {from: 3, to: 7},
        {from: 7, to: 14},
        {from: 14, to: null}
      ],
      contractTimeGroup: [
        {from: null, to: 3},
        {from: 3, to: 6},
        {from: 6, to: 12},
        {from: 12, to: null},
      ],
      contractValueGroup: [
        {from: null, to: 10},
        {from: 10, to: 20},
        {from: 20, to: 50},
        {from: 50, to: null},
      ],
      clientSizeGroup: [
        {from: null, to: 10},
        {from: 10, to: 20},
        {from: 20, to: 50},
        {from: 50, to: 100},
        {from: 100, to: null},
      ]
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    load() {
      let loader = this.$loading.show();
      this.loading = true;
      this.$service.get('/report/contract', { params: this.filterFormModel }).then(response => {
        this.sum = {};
        this.avg = {};
        this.data = [];
        if (!this.filterFormModel.from || !this.filterFormModel.to) {
          this.filterFormModel.to = moment(Date.now(), 'x').endOf('day').format('x');
          this.filterFormModel.from = moment(Date.now(), 'x').subtract('29', 'day').startOf('day').format('x');
        }
        let newData = [];
        response.data.new.forEach(item => {
          if ((!['day', 'week', 'month'].includes(this.filterFormModel.group) && (!item._id || !item.label))) { 
            item._id = -1;
            item.label = this.$t('notChoose'); 
          }
          item.saleTime = item.saleTime/8.64e+7;
          item.total = item.total / 1000000;
          let index = newData.findIndex(d => d._id === item._id);
          let saleTimeIndex = this.getGroupIndex(item.saleTime, this.saleTimeGroup);
          let clientSizeIndex = this.getGroupIndex(item.userLimit, this.clientSizeGroup);
          let contractValueIndex = this.getGroupIndex(item.total, this.contractValueGroup);
          let contractTimeIndex = this.getGroupIndex(item.monthCount, this.contractTimeGroup);
          if (index === -1) {
            let _item = {
              _id: item._id, 
              label: item.label,
              total: 1,
              saleTime: {},
              clientSize: {},
              contractTime: {},
              contractValue: {},
              minSaleTime: item.saleTime, 
              sumSaleTime: item.saleTime,
              maxSaleTime: item.saleTime,
              minContractTime: item.monthCount, 
              sumContractTime: item.monthCount,
              maxContractTime: item.monthCount,
            }
            if (saleTimeIndex) { _item.saleTime[saleTimeIndex] = 1 }
            if (clientSizeIndex) { _item.clientSize[clientSizeIndex] = 1 }
            if (contractValueIndex) { _item.contractValue[contractValueIndex] = 1 }
            if (contractTimeIndex) { _item.contractTime[contractTimeIndex] = 1 }
            newData.push(_item);
          } else {
            newData[index].total++;
            if (clientSizeIndex) {
              if (!newData[index].clientSize[clientSizeIndex]) {
                newData[index].clientSize[clientSizeIndex] = 1;
              } else {
                newData[index].clientSize[clientSizeIndex]++;
              }
            }
            if (contractValueIndex) {
              if (!newData[index].contractValue[contractValueIndex]) {
                newData[index].contractValue[contractValueIndex] = 1;
              } else {
                newData[index].contractValue[contractValueIndex]++;
              }
            }
            if (contractTimeIndex) {
              if (!newData[index].contractTime[contractTimeIndex]) {
                newData[index].contractTime[contractTimeIndex] = 1;
              } else {
                newData[index].contractTime[contractTimeIndex]++;
              }
            }
            if (saleTimeIndex) {
              if (!newData[index].saleTime[saleTimeIndex]) {
                newData[index].saleTime[saleTimeIndex] = 1;
              } else {
                newData[index].saleTime[saleTimeIndex]++;
              }
              newData[index].minSaleTime = Math.min(newData[index].minSaleTime, item.saleTime);
              newData[index].maxSaleTime = Math.max(newData[index].maxSaleTime, item.saleTime);
              newData[index].sumSaleTime += item.saleTime;
              newData[index].minContractTime = Math.min(newData[index].minContractTime, item.monthCount);
              newData[index].maxContractTime = Math.max(newData[index].maxContractTime, item.monthCount);
              newData[index].sumContractTime += item.monthCount;
            }
          }
        });
        let extendData = [];
        response.data.extend.forEach(item => {
          if ((!['day', 'week', 'month'].includes(this.filterFormModel.group) && (!item._id || !item.label))) { 
            item._id = -1;
            item.label = this.$t('notChoose'); 
          }
          item.saleTime = item.saleTime/8.64e+7;
          item.total = item.total / 1000000;
          let index = extendData.findIndex(d => d._id === item._id);
          let clientSizeIndex = this.getGroupIndex(item.userLimit, this.clientSizeGroup);
          let contractValueIndex = this.getGroupIndex(item.total, this.contractValueGroup);
          let contractTimeIndex = this.getGroupIndex(item.monthCount, this.contractTimeGroup);
          if (index === -1) {
            let _item = {
              _id: item._id, 
              label: item.label,
              total: 1,
              saleTime: {},
              clientSize: {},
              contractTime: {},
              contractValue: {},
              minContractTime: item.monthCount, 
              sumContractTime: item.monthCount,
              maxContractTime: item.monthCount,
            }
            if (clientSizeIndex) { _item.clientSize[clientSizeIndex] = 1 }
            if (contractValueIndex) { _item.contractValue[contractValueIndex] = 1 }
            if (contractTimeIndex) { _item.contractTime[contractTimeIndex] = 1 }
            extendData.push(_item);
          } else {
            extendData[index].total++;
            if (clientSizeIndex) {
              if (!extendData[index].clientSize[clientSizeIndex]) {
                extendData[index].clientSize[clientSizeIndex] = 1;
              } else {
                extendData[index].clientSize[clientSizeIndex]++;
              }
            }
            if (contractValueIndex) {
              if (!extendData[index].contractValue[contractValueIndex]) {
                extendData[index].contractValue[contractValueIndex] = 1;
              } else {
                extendData[index].contractValue[contractValueIndex]++;
              }
            }
            if (contractTimeIndex) {
              if (!extendData[index].contractTime[contractTimeIndex]) {
                extendData[index].contractTime[contractTimeIndex] = 1;
              } else {
                extendData[index].contractTime[contractTimeIndex]++;
              }
            }
              extendData[index].minContractTime = Math.min(extendData[index].minContractTime, item.monthCount);
              extendData[index].maxContractTime = Math.max(extendData[index].maxContractTime, item.monthCount);
              extendData[index].sumContractTime += item.monthCount;
            }
          }
        );
        //
        newData.forEach(item => {
          item.avgSaleTime = item.sumSaleTime / item.total;
          item.avgContractTime = item.sumContractTime / item.total;
          this.data.push({_id: item._id, label: item.label, new: item})
        });
        extendData.forEach(item => {
          item.avgContractTime = item.sumContractTime / item.total;
          let index = this.data.findIndex(d => d._id === item._id);
          if (index === -1) {
            this.data.push({_id: item._id, label: item.label, extend: item});
          } else {
            this.data[index].extend = item;
          }
        }); 
        if (this.filterFormModel.group === 'plan') {
          this.sum.register = response.data.register[0].register;
          this.avg.register = response.data.register[0].register / this.data.length;
          this.data.forEach((item, index) => {
            if (item.new && item.new.total && this.sum.register) { 
              this.data[index].new.buyNewRate = item.new.total / this.sum.register * 100;
            }
          });
        } else {
          response.data.register.forEach(item => {
            if ((!['day', 'week', 'month'].includes(this.filterFormModel.group) && (!item._id || !item.label))) { 
              item._id = -1;
              item.label = this.$t('notChoose'); 
            }
            let index = this.data.findIndex(d => d._id === item._id);
            if (index === -1) {
              this.data.push({_id: item._id, label: item.label, new: {register: item.register}});
            } else {
              if (!this.data[index].new) {
                this.data[index].new = {};
              } else {
                if (this.data[index].new.total && item.register) {
                  this.data[index].new.buyNewRate = this.data[index].new.total / item.register * 100;
                }
              }               
              this.data[index].new.register = item.register;
            }
          });
        }
        this.data.sort((a, b) => {
          if (a._id == -1) {
           return 1; 
          }
          if (b._id == -1) {
           return -1; 
          }
          return b._id - a._id
        });
        //
        this.data.forEach(item => {
          for (let prop in item) {
            if (!this.sum[prop]) {
              this.sum[prop] = {};
            }
            if (['new', 'extend'].includes(prop)) {
              for (let key in item[prop]) {
                if (!['_id', 'label', 'clientSize', 'saleTime', 'contractValue', 'contractTime'].includes(key)) {
                  item[prop][key] = Math.abs(item[prop][key]);
                  if (this.sum[prop][key]) {
                    this.sum[prop][key] += item[prop][key];
                  } else {
                    this.sum[prop][key] = item[prop][key]
                  }
                }
                if (['clientSize', 'saleTime', 'contractValue', 'contractTime'].includes(key)) {
                  for (let subKey in item[prop][key]) {
                    if (!this.sum[prop][key]) {
                      this.sum[prop][key] = {};
                    }
                    if (!this.sum[prop][key][subKey]) {
                      this.sum[prop][key][subKey] = item[prop][key][subKey];
                    } else {
                      this.sum[prop][key][subKey] += item[prop][key][subKey];
                    }
                  }
                }
              }
            }
          }
        });
        for (let prop in this.sum) {
          if (['new', 'extend'].includes(prop)) {
            this.avg[prop] = {};
            for (let key in this.sum[prop]) {
              if (!['_id', 'label', 'clientSize', 'saleTime', 'contractValue', 'contractTime'].includes(key)) {
                this.avg[prop][key] = Math.round(this.sum[prop][key] / this.data.length);
              }
              if (['clientSize', 'saleTime', 'contractValue', 'contractTime'].includes(key)) {
                this.avg[prop][key] = {};
                for (let subKey in this.sum[prop][key]) {
                  this.avg[prop][key][subKey] = Math.round(this.sum[prop][key][subKey] / this.data.length);
                }
              }
            } 
          }
        }
      }).finally(() => {
        loader.hide();
        this.loading = false;
      });
    },
    getGroupIndex(value, groups) {
      for (const i in groups) {     
        if (!groups[i].from && groups[i].to) {
          if (value < groups[i].to) {
            return i;
          }
        }
        if (groups[i].from && !groups[i].to) { 
          if (value >= groups[i].from) {
            return i;
          }
        }
        if (groups[i].from && groups[i].to) { 
          if (value >= groups[i].from && value < groups[i].to) {
            return i;
          }
        }
      }
    },
    getGroupHeader(item) {
      if (!item.from && item.to) {
        return `< ` + item.to;
      }
      if (item.from && !item.to) {
        return `>= ` + item.from;
      }
      if (item.from && item.to) {
        // return item.from + ' - ' + item.to;
        return `< ` + item.to;
      }
    },
    label(item) {
      if (item.label) {
        return item.label;
      }
      if (!isNaN(item._id)) {
        if (this.filterFormModel.group === 'day') {
          return moment(item._id, 'x').format('ll');
        }
        if (this.filterFormModel.group === 'week') {
          return `${moment(item._id, 'x').format('ll')} --> ${moment(item._id, 'x').add(6, 'day').format('ll')}`;
        }
        if (this.filterFormModel.group === 'month') {
          return moment(item._id, 'x').startOf('month').format('MM/YYYY');
        }
      }
    },
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        reportContract: 'Contract report',
        day: "day",
        million: "million",
        month: "month",
        byDays: 'By days',
        byWeeks: 'By weeks',
        byMonths: 'By months',
        byPlans: 'By plan',
        bySales: 'By sales',
        byAccounts: 'By supporter',
        byCategories: 'By categories',
        shortest: "Shortest",
        longest: "Longest",
        buyNewContract: "Buy new contract",
        extendContract: "Extend contract",
        registerRate: "Register rate",
        buyNewRate: "Buy new rate",
        extendRate: "Extend rate",
        saleTime: "Sale time",
        contractTime: "Contract time",
        contractNumber: "Contract number",
        contractNumberByUser: "Contract number by user",
        contractNumberBySaleTime: "Contract nubmer by pos time",
        contractNumberByValue: "Contract nubmer by value",
        contractNumberByTime: "Contract nubmer by time",
        notChoose: "Not choose",
      },
      vi: {
        reportContract: 'Báo cáo hợp đồng',
        day: "ngày",
        month: "tháng",
        million: "triệu",
        byDays: 'Theo ngày',
        byWeeks: 'Theo tuần',
        byMonths: 'Theo tháng',
        byPlans: 'Theo gói',
        bySales: 'Theo sales',
        byAccounts: 'Theo chăm sóc',
        byCategories: 'Theo ngành',
        shortest: "Ngắn nhất",
        longest: "Dài nhất",
        buyNewContract: "Hợp đồng mua mới",
        extendContract: "Hợp đồng gia hạn",
        registerRate: "Tỷ lệ khách đăng ký",
        buyNewRate: "Tỷ lệ khách mua mới",
        extendRate: "Tỷ lệ khách gia hạn",
        saleTime: "Thời gian chốt",
        contractTime: "Thời gian hợp đồng",
        contractNumber: "Số lượng hợp đồng",
        contractNumberByUser: "Số lượng hợp đồng theo quy mô user",
        contractNumberBySaleTime: "Số lượng hợp đồng theo thời gian chốt",
        contractNumberByValue: "Số lượng hợp đồng theo mức giá trị",
        contractNumberByTime: "Số lượng hợp đồng theo thời hạn",
        notChoose: "Chưa xác định",
      }
    }
  }
};
</script>